export enum ButtonStatus {
	FIRST_BUTTON = 0,
	SECOND_BUTTON = 1,
	THIRD_BUTTON = 2,
	FOURTH_BUTTON = 3,
}
